export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14393.f681146f.jpg";